// Structural type covering both Array and the typed-array prototypes that share
// these monkeypatched methods.
type IndexedNumbers = { length: number; [i: number]: number };

if (Array.prototype.set === undefined) {
  Array.prototype.set = function set(
    this: IndexedNumbers,
    array: ArrayLike<number>,
    src?: number,
    dst?: number,
    count?: number
  ) {
    src = src === undefined ? 0 : src;
    dst = dst === undefined ? 0 : dst;
    count = count === undefined ? array.length : count;

    if (count < 0) {
      throw new RangeError("Count must be >= zero");
    }

    let len = Math.min(this.length - dst, array.length - src);
    len = Math.min(len, count);

    for (let i = 0; i < len; i++) {
      this[dst + i] = array[src + i];
    }

    return this;
  };

  Float64Array.prototype.set = Array.prototype.set;
  Float32Array.prototype.set = Array.prototype.set;
  Uint8Array.prototype.set = Array.prototype.set;
  Uint8ClampedArray.prototype.set = Array.prototype.set;
  Int32Array.prototype.set = Array.prototype.set;
  Int16Array.prototype.set = Array.prototype.set;
  Int8Array.prototype.set = Array.prototype.set;
}

if (Array.prototype.reject === undefined) {
  Array.prototype.reject = function reject<T>(this: T[], func: (item: T) => boolean) {
    return this.filter((item) => !func(item));
  };
}

// The target runtime always has Symbol; only stamp the keystr identity slot used
// by the set/hashtable collections and the Class identity system.
Symbol.keystr = Symbol("keystr");

window.list = function list(iter: Iterable<unknown> | ArrayLike<unknown>) {
  const ret = [];

  if (typeof iter == "string") {
    iter = new String() as unknown as ArrayLike<unknown>;
  }

  if (Symbol.iterator in iter) {
    for (const item of iter as Iterable<unknown>) {
      ret.push(item);
    }
  } else {
    (iter as unknown as { forEach(cb: (item: unknown) => void): void }).forEach(function (item) {
      ret.push(item);
    });
  }

  return ret;
};

if (Math.sign == undefined) {
  Math.sign = function sign(f: number) {
    return +(f > 0.0) * 2.0 - 1.0;
  };
}

if (Math.fract == undefined) {
  Math.fract = function fract(f: number) {
    return f - Math.floor(f);
  };
}

if (Math.tent == undefined) {
  Math.tent = function tent(f: number) {
    return 1.0 - Math.abs(Math.fract(f) - 0.5) * 2.0;
  };
}

window.time_ms = function () {
  return window.performance.now();
};

if (Array.prototype.clone == undefined) {
  Array.prototype.clone = function <T>(this: T[]) {
    return this.slice(0);
  };
}

if (Array.prototype.pop_i == undefined) {
  Array.prototype.pop_i = function <T>(this: T[], idx: number) {
    if (idx < 0 || idx >= this.length) {
      throw new Error("Index out of range");
    }

    const item = this[idx];
    while (idx < this.length) {
      this[idx] = this[idx + 1];
      idx++;
    }

    this.length -= 1;
    return item;
  };
}

if (Array.prototype.remove == undefined) {
  Array.prototype.remove = function <T>(this: T[], item: T, suppress_error?: boolean) {
    const i = this.indexOf(item);

    if (i < 0) {
      if (suppress_error) console.trace("Warning: item not in array", item);
      else throw new Error("Error: item not in array " + item);

      return;
    }

    this.pop_i(i);
  };
}

if (String.prototype.contains == undefined) {
  String.prototype.contains = function (this: string, substr: string) {
    return this.search(substr) >= 0;
  };
}

// keystr identity hooks for primitive boxes — keyed by the Symbol.keystr slot.
(String.prototype as unknown as Record<symbol, unknown>)[Symbol.keystr] = function keystr(
  this: string
) {
  return this;
};
const primitiveKeystr = function keystr(this: number | boolean) {
  return "" + this;
};
(Number.prototype as unknown as Record<symbol, unknown>)[Symbol.keystr] = primitiveKeystr;
(Boolean.prototype as unknown as Record<symbol, unknown>)[Symbol.keystr] = primitiveKeystr;
